module.exports = __webpack_public_path__ + "a8f85574edf30a57b51a86c9d6e1d4a0.svg";